import { defineComponent as _defineComponent } from 'vue'
import { AbSection, AbContainer, AbIcon, AbDescription } from '../../ui';
import { onMounted, ref, toRefs, reactive } from 'vue-demi';
import { Spacing } from '../../../helpers/shared-props';
import { useScroll } from '@vueuse/core';

interface Props {
  tabs: {
    title: string;
    text: string;
  }[];
  spacing?: Spacing;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ContentSectionTips',
  props: {
    tabs: null,
    spacing: null
  },
  setup(__props: any) {



const tabsRef = ref<any>();
const tabsNavRef = ref<any>();
const isTabsClosed = ref(false);
const state = reactive<{
  isBegin: any;
  isEnd: any;
}>({
  isBegin: null,
  isEnd: null,
});

const onClick = () => {
  isTabsClosed.value = true;
};

const onTabClick = () => {
  isTabsClosed.value = false;
};
const checkScroll = () => {
  if (!tabsRef.value) return;
  const tabsNav = tabsRef.value.shadowRoot.querySelector('.tab-group__nav');
  const { arrivedState } = useScroll(tabsNav);
  state.isBegin = toRefs(arrivedState).left;
  state.isEnd = toRefs(arrivedState).right;
};
onMounted(async () => {
  if (typeof window !== 'undefined') {
    await import('@shoelace-style/shoelace/dist/components/tab/tab');
    await import(
      '@shoelace-style/shoelace/dist/components/tab-group/tab-group'
    );
    await import(
      '@shoelace-style/shoelace/dist/components/tab-panel/tab-panel'
    );
    checkScroll();
  }
});

return { __sfc: true,tabsRef, tabsNavRef, isTabsClosed, state, onClick, onTabClick, checkScroll, AbSection, AbContainer, AbIcon, AbDescription }
}

})